import { render } from "./AssignInstance.vue?vue&type=template&id=215e3ab7&scoped=true"
import script from "./AssignInstance.vue?vue&type=script&lang=js"
export * from "./AssignInstance.vue?vue&type=script&lang=js"

import "./AssignInstance.vue?vue&type=style&index=0&id=215e3ab7&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215e3ab7"]])

export default __exports__